import { Link, LinkProps } from 'react-router-dom';
import React from 'react';
import classNames from 'classnames';

import styles from './ProductCardLink.module.scss';

export default function ProductCardLink({
  className,
  ...props
}: LinkProps): JSX.Element {
  return <Link className={classNames(styles.link, className)} {...props} />;
}
